import { gql } from '@apollo/client';

const DELETE_ECG_BOOKMARKS = gql`
  mutation deleteEcgBookmarks($ids: [ID!]!) {
    deleteEcgBookmarks(ids: $ids) {
      isSuccess
      message
    }
  }
`;

export default DELETE_ECG_BOOKMARKS;
